import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { addIcon, extendedSystemStyles } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["layout", "flexbox", "space", "color", "typography"];
var Component = styled.div.withConfig({
  displayName: "Icon__Component",
  componentId: "sc-1q6pmsl-0"
})(["&:before{", "}", "", ""], function (_ref) {
  var theme = _ref.theme,
    icon = _ref.icon;
  return addIcon(theme, icon, "auto");
}, function (_ref2) {
  var theme = _ref2.theme,
    inverted = _ref2.inverted;
  return "\n    display: flex;\n    height: 100%;\n    padding: 40px;\n    background: ".concat(inverted ? theme.colors.P3 : theme.colors.G1, ";\n    color: ").concat(inverted ? theme.colors.G1 : theme.colors.P1, ";\n  ");
}, extendedSystemStyles(styledSystemKeys));
var Icon = function Icon(props) {
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, props));
};
Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  inverted: PropTypes.bool
};
export default /*#__PURE__*/memo(Icon);